import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from '@mui/material';

const pathnames = {
  'requisiciones': 'Requisiciones',
  'solicitudes_cotizacion': 'RFQs',
  'ordenes-compra': 'Órdenes de Compra',
  'empresas': 'Empresas',
  'proveedores': 'Proveedores',
  'nueva': 'Nuevo',
  'nuevo': 'Nuevo',
  'editar': 'Editar',
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter((i) => i);

  return (
    <MuiBreadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link component={RouterLink} underline="hover" color="inherit" to="/">
        Inicio
      </Link>
      {pathSegments.map((value, index) => {
        const to = `/${pathSegments.slice(0, index + 1).join('/')}`;
        const isLast = index === pathSegments.length - 1;
        const displayName = pathnames[value] || value;

        return isLast ? (
          <Typography color="text.primary" key={to}>
            {displayName}
          </Typography>
        ) : (
          <Link component={RouterLink} underline="hover" color="inherit" to={to} key={to}>
            {displayName}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
